import React from "react";
import MetaTags from "./components/MetaTags";
import AppBar from "./components/AppBar";
import { Container, Row, Col } from "react-bootstrap";
import { PiMapPinSimpleAreaBold } from "react-icons/pi";
import { BiPhoneCall } from "react-icons/bi";
import { MdOutlineAlternateEmail } from "react-icons/md";
import Mark from "./components/Mark";
const ContactUs = () => {
  return (
    <div>
      <MetaTags
        title="Contact Us - Jaivanth Crackers - Whole sale Crackers"
        type="website"
        siteName="Jaivanthcrackers.com"
        url="https://Jaivanthcrackers.com/contactus"
        keywords="Contact Us | Jaivanth Crackers "
        description="Contact for wholesale Crackers and Retail Crackers"
        revisitAfter="10 Days"
      />
      <AppBar />
      <img
        src={require("../assets/images/banner/banner_two.jpg")}
        className="img-fluid w-100"
        alt="product name"
      />
      <Container className="padding">
        <Row>
          <Col xs={12} sm={12} md={12} lg={12} className="py-3">
            <div className="bold  text-center"> Contact Us</div>
          </Col>
          <Col lg="6" className="py-3">
            <Row>
              <Col lg="12" md="12" className="py-3">
                <div className="box">
                  <div className="box-icon">
                    <PiMapPinSimpleAreaBold size={40} color={"#000"} />
                  </div>
                  <div className="regular">
                   Near vembakottai EB office.vembakottai(Taluk),viruthunagar.<br />
                    
                  </div>
                </div>
              </Col>
              <Col lg="12" className="py-3">
                <div className="box">
                  <div className="box-icon">
                    <BiPhoneCall size={40} color={"#000"} />
                  </div>
                  <div>
                    <li>+91 9443155605</li>
                    <li>+91 9843660591</li>
                  </div>
                </div>
              </Col>
              <Col lg="12" className="py-3">
                <div className="box">
                  <div className="box-icon">
                    <MdOutlineAlternateEmail size={40} color={"#000"} />
                  </div>
                  <div className="pb-4">
                    <div>Jaivanthcrackers@gmail.com</div>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>

          <Col lg="6" md="6" xs="12" className="py-5">
            <>
             <iframe src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d2998.729737198842!2d77.77410707502285!3d9.351497090723262!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zOcKwMjEnMDUuNCJOIDc3wrA0NiczNi4xIkU!5e1!3m2!1sen!2sin!4v1769415751911!5m2!1sen!2sin" 
             width="600" height="450" style={{border:0}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
            </>
          </Col>
        </Row>
      </Container>

      <>
        <Mark />
      </>
    </div>
  );
};

export default ContactUs;
